<nb-card>
    <ubs-ofbiz-list 
    [fieldOptions]="fieldOptions" 
    [listOptions]="listOptions" 
    title="title" [state]="state$" 
    (overViewSelected)="showOverview($event)" 
    [searchResults]="result" 
    (editSelected)="showEditDialog($event)"
    (rowSelected)="rowSelected($event)" 
    [columnFields]="columnFields"
    [columnFieldTitles]="columnFieldTitles"
    [remoteFormData]="remoteFormData">
</ubs-ofbiz-list>
</nb-card>

